import React from "react";
import { Row, Col, Timeline, Divider, Tooltip } from "antd";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import tableNameImg from "../../../assets/images/table.png";
import totalAmountImg from "../../../assets/images/totalAmount.png";
import waiterNameImg from "../../../assets/images/waiter.png";
import address from "../../../assets/images/address.jpg";
import countOrdersImg from "../../../assets/images/orderCount.png";
import minutesImg from "../../../assets/images/minutes.png";
import distanceImg from "../../../assets/images/distance.png";
import calendarImg from "../../../assets/images/calendar.png";
import "./index.css";

const OrderInfoModalContent = ({ record }) => {
  const { bill } = useSelector((state) => state.tablesInfoReducer);

  return (
    <>
      <div className="orders-drivers-info-modal-content-container">
        <Row>
          <Col
            span={24}
            className="orders-drivers-info-modal-content-first-col"
          >
            <Tooltip placement="right" title="Доставчик">
              <img src={waiterNameImg} alt="waiterNameImg" width="20px" />
            </Tooltip>
            <span>{record[0].driverName}</span>
          </Col>
        </Row>

        <Row>
          <Col
            className="orders-drivers-info-modal-content-first-col"
            span={12}
          >
            <Tooltip placement="right" title="Номер на поръчка">
              <img src={tableNameImg} alt="tableNameImg" width="20px" />
            </Tooltip>
            <span>{record[0].tableName}</span>
          </Col>

          <Col
            className="orders-drivers-info-modal-content-second-col"
            span={12}
          >
            <Tooltip placement="right" title="Времетраене">
              <img src={minutesImg} alt="minutesImg" width="20px" />
            </Tooltip>
            <span>
              {record[0].accepted !== "0001-01-01T00:00:00"
                ? dayjs(record[0].closed, {
                    format: "YYYY-MM-DDTHH:mm:ss.SSS",
                  }).diff(
                    dayjs(record[0].accepted, {
                      format: "YYYY-MM-DDTHH:mm:ss.SSS",
                    }),
                    "minutes"
                  )
                : dayjs(record[0].closed, {
                    format: "YYYY-MM-DDTHH:mm:ss.SSS",
                  }).diff(
                    dayjs(record[0].created, {
                      format: "YYYY-MM-DDTHH:mm:ss.SSS",
                    }),
                    "minutes"
                  )}{" "}
              мин
            </span>
          </Col>
        </Row>

        <Row>
          <Col
            className="orders-drivers-info-modal-content-first-col"
            span={12}
          >
            <Tooltip placement="right" title="Брой поръчки">
              <img src={countOrdersImg} alt="countOrdersImg" width="20px" />
            </Tooltip>
            <span>{bill[0]?.orders.length}</span>
          </Col>

          <Col
            className="orders-drivers-info-modal-content-second-col"
            span={12}
          >
            <Tooltip placement="right" title="Обща сума">
              <img src={totalAmountImg} alt="totalAmountImg" width="20px" />
            </Tooltip>
            <span>
              {bill[0]?.orders
                .reduce((sum, order) => sum + order.totalAmount, 0)
                .toFixed(2)}
            </span>
          </Col>
        </Row>

        <Row>
          <Col
            span={20}
            className="orders-drivers-info-modal-content-first-col"
          >
            <Tooltip placement="right" title="Адрес">
              <img src={address} alt="addressImg" width="20px" />
            </Tooltip>
            <span>{record[0].adress}</span>
          </Col>
        </Row>

        <Row>
          <Col
            className="orders-drivers-info-modal-content-first-col"
            span={12}
          >
            <Tooltip placement="right" title="Дата">
              <img src={calendarImg} alt="calendarImg" width="20px" />
            </Tooltip>
            <span>{dayjs(record[0].accepted).format("DD.MM.YYYY")}</span>
          </Col>

          <Col
            className="orders-drivers-info-modal-content-second-col"
            span={12}
          >
            <Tooltip placement="right" title="Разстояние">
              <img src={distanceImg} alt="distanceImg" width="25px" />
            </Tooltip>
            <span>
              {record[0]?.geocoding?.distanceBetweenLocationsInMeters !==
              undefined
                ? Math.round(
                    record[0]?.geocoding?.distanceBetweenLocationsInMeters
                  ) + " метра"
                : "-"}
            </span>
          </Col>
        </Row>

        <Divider className="orders-drivers-info-modal-content-divider" />
      </div>
      <div className="orders-drivers-info-modal-content-timeline">
        <Timeline
          items={[
            {
              style: { padding: 0 },
              color: "gray",
              children: (
                <p>
                  <b>
                    {record[0].accepted?.split("T")[1]?.split(".")[0]} Получена{" "}
                  </b>
                </p>
              ),
            },
            {
              style: { padding: 0 },
              color: "green",
              children: (
                <p>
                  <b>
                    {record[0].created?.split("T")[1]?.split(".")[0]} Отваряне
                    на сметка{" "}
                  </b>
                </p>
              ),
            },
            ...bill.map((x) => ({
              style: { padding: 0 },
              color: "gray",
              children: [
                ...(x.orders || []).map((z, index) => (
                  <p key={`order-${z.itemId}-${index}`}>
                    {parseFloat(z.quantity).toFixed(2)} x{" "}
                    {parseFloat(z.price).toFixed(2)}€ - {z.itemName}
                  </p>
                )),
              ],
            })),
            {
              style: { padding: 0 },
              color: "orange",
              children: (
                <p>
                  <b>
                    {record[0].executed?.split("T")[1]?.split(".")[0]}{" "}
                    Изпълнение{" "}
                  </b>
                </p>
              ),
            },
            {
              style: { padding: 0 },
              color: "blue",
              children: (
                <p>
                  <b>
                    {record[0].moved?.split("T")[1]?.split(".")[0] !==
                    "00:00:00"
                      ? record[0].moved?.split("T")[1]?.split(".")[0] +
                        " Назначаване"
                      : "Липсва операция -  Назначаване"}
                  </b>
                </p>
              ),
            },
            record[0].closed && {
              style: { padding: 0 },
              color: "red",
              children: (
                <p>
                  <b>
                    {record[0].closed?.split("T")[1]?.split(".")[0]} Закриване
                    на сметка{" "}
                  </b>
                </p>
              ),
            },
            {
              style: { padding: 0 },
              color: "gray",
              children: (
                <p>
                  <b>
                    {record[0].expected?.split("T")[1]?.split(".")[0]} Очаквана{" "}
                  </b>
                </p>
              ),
            },
          ]}
        />
      </div>
    </>
  );
};

export default OrderInfoModalContent;
